import React from 'react';
import parser from 'html-react-parser';

export default function IconBoxStyle6({ title, subTitle, iconUrl, showIcon = true }) {
  console.log("iconUrl",iconUrl)
  
  // Process subTitle to add styling for ul and li elements
  const processedSubTitle = subTitle
    ?.replace(/<ul>/g, '<ul style="list-style-type: disc; padding-left: 20px; line-height: 2.5;">')
    ?.replace(/<li>/g, '<li style="margin-bottom: 12px; line-height: 2;">')
    ?.replace(/<p class="tech-text">/g, '<p class="tech-text" style="font-weight: 700; font-size: 20px; margin-top: 20px; line-height: 1.6;">');
  
  return (
    <div className="cs_iconbox cs_style_6">
      {showIcon && iconUrl && (
        <div className="cs_iconbox_icon cs_center cs_accent_bg rounded-circle">
          <img src={iconUrl} alt="Icon" />
        </div>
      )}
      <h2 className="cs_iconbox_title cs_fs_32 cs_semibold">{parser(title)}</h2>
      <div 
        className="cs_iconbox_subtitle m-0"
        dangerouslySetInnerHTML={{ __html: processedSubTitle }}
      />
    </div>
  );
}
